<div class="p-grid">
  <div class="p-col header-info">
    <div class="p-grid">
      <div class="p-col-2">
        <span class="property-search-label">Import Date</span> <br />
        <span class="property-search-values">{{property?.ImportDate | dateTimeFormat}}</span>
      </div>
      <div class="p-col-2">
        <span class="property-search-label">Initial Secure Date</span> <br />
        <span class="property-search-values">{{property?.InitialSecureDate | dateTimeFormat}}</span>
      </div>
      <div class="p-col-2">
        <span class="property-search-label">High Priority</span><br />
        <span class="property-search-values">{{property.HighPriorityIndicator ? 'Yes' : 'No'}}</span>
      </div>
      <div class="p-col-3">
        <span class="property-search-label">Code Violations</span><br />
        <span class="property-search-values">{{property.EQCodeViolations ? 'Yes' : 'No'}}</span>
      </div>
      <div class="p-col-3">
        <span class="property-search-label">Occupant Threat</span><br />
        <span class="property-search-values">{{property.EQOccupancyThreat ? 'Yes' : 'No'}}</span>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-2">
        <span class="property-search-label">UPB</span> <br />
        <span class="property-search-values">{{property?.CurrentUPB}}</span>
      </div>
      <div class="p-col-2">
        <span class="property-search-label">Expenses-Maintenance</span> <br />
        <span class="property-search-values">{{property?.ExpenseMaintenance | currency}}</span>
      </div>
      <div class="p-col-2">
        <span class="property-search-label">Expenses-Repairs</span><br />
        <span class="property-search-values">{{property?.ExpenseRepairs | currency}}</span>
      </div>
      <div class="p-col-3">
        <span class="property-search-label">Inspection Vendor</span><br />
        <span class="property-search-values">{{property?.InspectionVendor}}</span>
      </div>
      <div class="p-col-3">
        <span class="property-search-label">Field Services Vendor</span><br />
        <span class="property-search-values">{{property?.FieldservicesVendorName}}</span>
      </div>
    </div>
  </div>
</div>